import React from 'react'
import { Link } from 'gatsby'

const PageTitle = ({ title, backButtonDestination='', noCenter=false }) => {

  return (
    <>
      {title && (
        <div className={`page-title-wrapper px-2 py-6 ${(!noCenter) ? 'text-center' : ''}`}>

          {backButtonDestination && (
            <Link className="back-button" to={backButtonDestination}>
              <div className="back-icon"></div>
              <span>Back</span>
            </Link>
          )}
          <h1>{title}</h1>
        </div>
      )}
    </>
  )
}
export default PageTitle
